import React from "react";
import { Group, Modal as MantineModal } from "@mantine/core";
import { Button } from "../Button/Button";

type ModalValidationVariant = {
  type: "VALIDATION";
  buttonText: string;
  onClose?: () => void;
};
type ModalConfirmationVariant = {
  type: "CONFIRMATION";
  buttonText: string;
  onClose?: () => void;
  onConfirm?: () => void;
};
type ModalDefaultVariant = {
  type: "DEFAULT";
  onClose?: () => void;
};
type ModalVariant =
  ModalValidationVariant | ModalConfirmationVariant | ModalDefaultVariant;
export interface ModalProps {
  title?: string;
  isOpen: boolean;
  onConfirm?: () => void;
  children: React.ReactNode;
  variant?: ModalVariant;
  withCloseButton?: boolean;
  buttonPosition?: "left" | "right" | "center";
  size?: "sm" | "md" | "lg" | "xl";
  padding?: "sm" | "md" | "lg" | "xl";
  dataTestId?: string;
}

export const Modal: React.FC<ModalProps> = ({ ...props }: ModalProps) => {
  const buttonPosition = props.buttonPosition || "center";
  return (
    <MantineModal
      size={props.size || "md"}
      radius="md"
      centered
      withCloseButton={props.withCloseButton}
      opened={props.isOpen}
      onClose={props.variant.onClose}
      title={props.title}
      padding={props.padding}
    >
      <div {...(props.dataTestId && { "data-testid": props.dataTestId })}>
        {props.children}
        {(props.variant.type === "VALIDATION" ||
          props.variant.type === "CONFIRMATION") && (
          <div
            style={{
              display: "flex",
              justifyContent: buttonPosition,
              gap: "10px",
              marginTop: "10px",
            }}
          >
            {props.variant.type === "VALIDATION" && (
              <Button onClick={props.variant.onClose}>
                {props.variant.buttonText}
              </Button>
            )}
            {props.variant.type === "CONFIRMATION" && (
              <Group>
                <Button variant="outline" onClick={props.variant.onClose}>
                  Annuler
                </Button>
                <Button variant="validation" onClick={props.variant.onConfirm}>
                  {props.variant.buttonText}
                </Button>
              </Group>
            )}
          </div>
        )}
      </div>
    </MantineModal>
  );
};
